import { CHART_VISUAL_TYPES } from './config/nodeVisualConfig';

export const LAYOUT_CONFIG = {
    'data':      { x: 50,  startY: 500 },
    'visual':    { x: 500,  startY: 1500 },
    'indicator':    { x: 1500, startY: 100 },
    'math':         { x: 2000, startY: 100 },
    'comparator':   { x: 2500, startY: 100 },
    'logic_gate':   { x: 3000, startY: 100 },
    'execution_entry': { x: 3500, startY: 100 },
    'execution_exit':  { x: 4000, startY: 100 },
    'output':       { x: 2000, startY: 1400 },
    'other':        { x: 4500, startY: 250 }
};

export const PADDING_Y = 32;
export const VISUAL_NODE_HEIGHT_PX = 180;
export const VISUAL_NODE_HEIGHT_CLASS = `h-[${VISUAL_NODE_HEIGHT_PX}px]`;

export const getLayoutCategory = (nodeType, dataArg = null) => {
    if (CHART_VISUAL_TYPES.includes(nodeType)) return 'visual';
    if (nodeType === 'indicator') return 'indicator';
    if (nodeType === 'math') return 'math';
    if (nodeType === 'comparator') return 'comparator';
    if (nodeType === 'logic_gate') return 'logic_gate';
    if (nodeType === 'position_trigger' || nodeType === 'position' || nodeType === 'signal') {
        const action = dataArg?.action || '';
        if (action.includes('exit') || action === 'sl' || action === 'tp' || action === 'time_exit') {
            return 'execution_exit';
        }
        return 'execution_entry';
    }
    if (nodeType === 'data_source') return 'data';
    if (nodeType === 'chart_node' || nodeType === 'chart_output') return 'output';
    return 'other';
};

export const NODE_HEIGHTS = {
    'data_source': 180,
    'candle_node': 180,
    'heikin_node': 180,
    'line_node': 180,
    'area_node': 180,
    'volume_node': 180,
    'bar_node': 180,
    'indicator': 90,
    'position_trigger': 120, // Increased to account for header + action row + support text
    'chart_node': 150,
    'chart_output': 150,
    'comparator': 130, // Increased
    'logic_gate': 130, // Increased
    'math': 160,      // Added and set to higher value (usually 2+ inputs)
    'signal': 120,    // Synced with position_trigger
    'position': 120   // Synced with position_trigger
};

export const calculateNodeHeight = (node) => {
    let h = NODE_HEIGHTS[node.type] || 120;
    if (node.type === 'indicator') {
         const paramCount = node.data?.params ? Object.keys(node.data.params).length : 0;
         const visibleParams = Math.min(paramCount, 6);
         const rows = Math.ceil(visibleParams / 3);
         h = 70 + (rows * 35);
    }
    return h;
};
